import React from "react";
import { makeStyles } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useSelector ,useDispatch} from "react-redux";
import { useSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import AsideMenu from "../../../app/components/AsideMenu";
import ConfigurationSideBar from "../../../app/modules/Configuration/pages/Configuration/Reports/ReportsSidebar";
import FeedbackButton from "../../../app/modules/Feedback_Form";
import { C2CWidget } from "../../../app/modules/Ticker/C2C";
import * as tickerConstants from "../../../app/modules/Ticker/constants";
import { Debugger } from "../../../app/modules/Ticker/Debugger";
import { SIPPhone } from "../../../app/modules/Ticker/sip/SIPPhone";
import * as helpers from "../../../app/util/helpers";
import { Loader2 } from "../../../app/util/loading";
import "../../_assets/sass/base.scss";
import { ScrollTop } from "./extras/ScrollTop";
import { Footer } from "./footer/Footer";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Header } from "./header/Header";
import { TickerInit } from "./TickerInit";
import ChangePassword from "../../../app/modules/Auth/pages/ChangePassword";
import TermsAndConditionsModal from '../../../app/modules/TermsConditions/TermsCondition';
import { setSnackBar } from "../../../app/SnackbarUtils";
import  CallPopup  from "../../../../src/app/modules/WhatsappCall/CallPopup";
import { closeCallPopup } from '../../../../src/app/modules/WhatsappCall/callPopupSlice';


const useStyles = makeStyles((theme) => ({
  mainArea: {
    paddingLeft: 104,
    width: "100%",
    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
    },
  },
  header: {
    paddingTop: 2,
  },
}));

export function Layout({ children }) {
  const location = useLocation();
  const classes = useStyles();
  const [psuedoEl, setPsuedoEl] = useState(null);
  const dispatch = useDispatch();
  
  const sip_connected = useSelector((state) =>
    state.ticker.sip_connected ? state.ticker.sip_connected : false
  );

  const { extra_data } = useSelector(({ auth }) => ({
    extra_data: auth.extra_data,
  }));

  const isDuplicatedTab = useSelector(state => state.auth.is_duplicated_tab);

  const [openMobileAsideMenu, setOpenMobileAsideMenu] = useState(false);
  const [open, setOpen] = useState(true);

  const {enqueueSnackbar} = useSnackbar();

  useEffect(() => {
    setSnackBar(enqueueSnackbar);
  },[enqueueSnackbar])

  const handleClose = () => {
    setOpen(false);
  };
  let assumeId = localStorage.getItem("assume_id");
  assumeId = (assumeId === 'null' || assumeId === '' || assumeId === 'None') ? false : assumeId;
 
  const layoutContentWrapper = (layout) => {
    switch (layout) {
      case "Reports":
        return <ConfigurationSideBar />;
      default:
        break;
    }
  };

  const handleMobileAsideMenu = () => {
    setOpenMobileAsideMenu((prev) => !prev);
  };
  const handleCloseCallPopup = () => {
    dispatch(closeCallPopup());
  };

 const isCallPopupOpen = useSelector(state => {
      return state.callPopupSlice?.isCallPopupOpen ?? false;
  });
 


  const LIVE_INTERACTIONS = "Live Interactions";

  const paths = {
    "/dashboard": "Dashboard",
    "/insights": "Insights",
    "/live-interactions/call-monitor": LIVE_INTERACTIONS,
    "/live-interactions/queue-monitor": LIVE_INTERACTIONS,
    "/call-logs": "Call Logs",
    "/smslogs": "SMS Logs",
    "/whatsapplogs": "WhatsApp Outbound Logs",
    "/customer-management": "Customer Management",
    "/phonebooks": "Phonebooks",
    "/dispositions": "Dispositions",
    "/reports": "Reports",
    "/templates": "Templates",
    "/sounds": "Sounds",
    "/sticky-agent": "Sticky Agents",
    "/hookapi": "Hook API",
    "/agentsettings": "Agent Settings",
    "/queueSettings": "Queue Settings",
    "/callflow": "Call Flow",
    "/smsflow": "SMS Flow",
    // "/callgroups": "Call Groups",
    "/integrations": "Integrations",
    "/campaign": "Campaign",
    "/createcampaign": "Create Campaign",
    '/settings': "Settings",
    '/invoices': "Invoices",
    '/billing_summary': "Billing Summary",
    '/account_profile': "Profile",
    '/history': "History",
    '/payments': "Payments & Plans",
    '/billstatement': "Bill Statement",
  };

  return (
    <>
      <HeaderMobile
        handleMobileAsideMenu={handleMobileAsideMenu}
        isMenuOpened={openMobileAsideMenu}
        paths={paths}
      />
      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-row flex-column-fluid page">
          <AsideMenu
            openMobileAsideMenu={openMobileAsideMenu}
            handleMobileAsideMenu={handleMobileAsideMenu}
          />
          <div
            className={`d-flex flex-column flex-row-fluid wrapper ${classes.mainArea}`}
            id="kt_wrapper"
          >
            <Header paths={paths} setPsuedoEl={setPsuedoEl} />
            <div
              className={`content d-flex flex-column flex-column-fluid ${classes.header}`}
            >
              <Loader2 resource="update_userStatus" />
              <Loader2 resource="iframe_logout" />
              {psuedoEl && !helpers.isFeatureEnabledProfile('hide_iframe_redirection') && <div className='transparent-mask'></div>}
              
              {helpers.isTickerModuleEnabled() && (
                <>
                  {true && <TickerInit key={sip_connected.toString()} />}
                  {true && <C2CWidget />}
                  {true && !isDuplicatedTab && helpers.isFeatureEnabledProfile("sip_url_flag") && (
                    <SIPPhone />
                  )}
                  {true && tickerConstants.TICKER_DEBUG_PANEL && <Debugger />}
                </>
              )}
              <>{children}</>
              {!helpers.isFeatureEnabledProfile('is_terms_accepted') && !assumeId && !helpers.isAgent() && !helpers.isSuperVisor() && (
                <TermsAndConditionsModal open={open} handleClose={handleClose} />
              )}
              {
                !helpers.isAgent() && !helpers.isSuperVisor() && 
                <ChangePassword />
              }
              <Footer />
              
              {helpers.isFeatureEnabledProfile('is_whatsapp_voice_enabled')  &&
              <CallPopup
              isOpen={isCallPopupOpen} // Pass the state as a prop
              onClose={handleCloseCallPopup} // Pass the close handler as a prop
              />
              }
              <FeedbackButton />
            </div>
          </div>
        </div>
      </div>
      <ScrollTop />
    </>
  );
}
